'use client';

import { animationSpring, animationTimingStyle, borderAnimation } from '@/styles/animation';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

interface AddToCartButtonProps {
	isLoading: boolean;
	onClick?: () => void;
	addToCartLabel: string;
	fullWidth?: boolean;
	state: 'none' | 'success';
	successLabel: string;
	disabled?: boolean;
	disabledLabel?: string;
}

export default function AddToCartButton({
	isLoading,
	onClick,
	addToCartLabel,
	fullWidth,
	state,
	successLabel,
	disabled = false,
	disabledLabel,
}: Readonly<AddToCartButtonProps>) {
	const successState = state === 'success';

	const getIcon = () => {
		if (successState)
			return (
				<TaskAltIcon
					sx={{
						animation: animationSpring,
						animationTimingFunction: animationTimingStyle,
					}}
				/>
			);
		if (disabled && disabledLabel) return false;
		return <AddShoppingCartIcon />;
	};

	const getButtonLabel = () => {
		if (successState) return successLabel;
		if (disabled && disabledLabel) return disabledLabel;
		return addToCartLabel;
	};

	return (
		<Button
			disabled={disabled}
			variant={isLoading || successState ? 'outlined' : 'contained'}
			startIcon={getIcon()}
			onClick={onClick}
			fullWidth={fullWidth}
			sx={{
				backgroundColor: isLoading || successState ? 'white' : 'primary.main',
				'.MuiButton-startIcon': {
					animation: successState ? animationSpring : 'none',
					animationTimingFunction: successState ? animationTimingStyle : 'none',
				},
				animation: isLoading ? `${borderAnimation} 1s infinite` : 'none',
			}}
			data-testid="add-to-cart-button"
		>
			<Box
				sx={{
					animation: successState ? animationSpring : 'none',
					animationTimingFunction: successState ? animationTimingStyle : 'none',
				}}
			>
				{getButtonLabel()}
			</Box>
		</Button>
	);
}
